import {ACTION_PROMISE, APP_CITY_SET_REQUEST, ALERT_ERROR, ALERT_HIDE, APP_SETTINGS_REQUEST, APP_SETTINGS_SET, APP_SETTING_CITY} from "../utils/Constant";
import * as API from "../api";

/**
 * @param data
 * @returns {{type: string}}
 */
export function hideAlert(data) {
  return {
    type: ALERT_HIDE,
  };
}

export function init(params) {
  return {
    type: ACTION_PROMISE,
    actions: [APP_SETTINGS_REQUEST, APP_SETTINGS_SET, ALERT_ERROR],
    promise: API.app.init(params),
  }
}

export function setCity(city) {
  saveCityToLocalStore(city);
  return {
    type: ACTION_PROMISE,
    actions: [APP_CITY_SET_REQUEST, APP_SETTINGS_SET, ALERT_ERROR],
    promise: API.app.setCity(city),
  }
}

export function saveCityToLocalStore(city) {
  localStorage.setItem(APP_SETTING_CITY, city);
}
